/** Warm-editorial tokens used by the coach's inline styles.
 *  Moved out of AICoach.tsx unchanged — do not retune values here. */
import { TOKENS } from '../ui/dashboard-primitives'

export const CREAM = TOKENS.cream;
// eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
export const CREAM_SOFT = "rgba(245, 237, 225, 0.78)";
// eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
export const CREAM_DIM = "rgba(245, 237, 225, 0.55)";
export const CREAM_FAINT = TOKENS.creamBorder;
export const AMBER = TOKENS.amber;
// eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
export const AMBER_TINT = "rgba(232, 197, 160, 0.14)";
// eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
export const AMBER_BORDER = "rgba(232, 197, 160, 0.38)";
export const TERRACOTTA = TOKENS.terracotta;
// eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
export const TERRACOTTA_SOFT = "rgba(198, 110, 77, 0.14)";
export const WARM_DARK = "rgba(28, 24, 22, 0.92)";
